module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vrassets/_next/static/images/frontZolaLogo-8b85fdbaa25dc27fa6c5d11e7ca9cb70.png";